<template>
  <div style="height: 100vh;margin-top: 10px" id="myhead">
    <div>
      <ul :style="{'min-height': (minHeight - 165) + 'px'}">
        <li v-if="object.showMenu" :key="index" v-for="( object , index) in menuObj" class="p_r">
          <span :class="object.active==activeName ? 'active' : '' " @click="toUrL(object)">
            <i :class="object.iconName"></i>
            <span style="display: inline-block;width: 65%;" class="Newline">{{object.name}}</span>
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'leftMenu',
  props: [
    'minHeight',
    'menuObj',
    'activeName'
  ],
  methods: { // 所有的方法封装
    toUrL (urlType) {
      this.$emit('update:activeName', urlType.active)
      localStorage.setItem('currMenu', urlType.active)
      this.$router.push({
        name: urlType.active
      })
    }
  }
}
</script>

<style scoped>
#myhead {
  /*margin-bottom: 50%;*/
  background-color: #f7f7f7;
  width: 60px;
  overflow: scroll;
  transition: all 0.3s;
  /*position: relative;*/
  /*z-index: 10;*/
}
::-webkit-scrollbar {
  /*隐藏滚轮*/
  display: none;
}
#myhead ul {
  padding: 10px 0;
}
#myhead li {
  width: 60px;
  overflow: hidden;
  transition: all 0.3s;
}
#myhead li > span {
  display: block;
  padding: 15px 10px;
  margin: 0;
  cursor: pointer;
  white-space: nowrap;
  word-break: break-all;
  color: #4c4461;
}
#myhead li > span:hover {
  background-color: #fdf1f4;
}
#myhead li > span i {
  font-size: 24px;
  margin-left: 7px;
}
/*#myhead li > span.active{*/
/*  background-color: #004368;*/
/*}*/
#myhead li > span.active i,
#myhead li > span.active span {
  color: #b62a40;
}
#myhead li > span i {
  /*color: #C73343;*/
}
#myhead li > span span {
  /*color: #333;*/
  width: 0;
  font-weight: bold;
  margin-left: 20px;
  display: inline-block;
  transition: all 0.5s;
  white-space: nowrap;
}
#myhead li dl {
  margin-top: -10px;
  max-width: 200px;
  width: 300%;
}
#myhead li dl dd {
  padding: 10px 0px 10px 50px;
  /*background: #28292B;*/
  text-align: left;
  margin: 5px 0;
}
#myhead li dl dd i {
  display: inline-block;
  vertical-align: middle;
  width: 5px;
  height: 5px;
  background-color: white;
  border-radius: 100px;
  margin-right: 10px;
}
#myhead li dl dd > span {
  display: inline-block;
  vertical-align: middle;
  white-space: normal;
  word-break: break-word;
  width: 60%;
}
#myhead li dl dd > abbr {
  display: inline-block;
  background-color: white;
  width: 24px;
  line-height: 24px;
  border-radius: 50%;
  color: #c73343;
  text-align: center;
}
#myhead li dl dd.active {
  background-color: #b50b35;
}
#myhead li a {
  display: block;
}
#myhead:hover, #myhead:hover li, #myhead:hover li:hover {
  min-width: 200px;
  width: auto;
}
#myhead:hover li span span, #myhead:hover li span span:hover {
  width: 65%;
  margin-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/left-menu/menu.vue